import React, { Component } from 'react'
import Spacing from 'components/Common/Spacing'
import HolidayLabModal from '../HolidayLabModals/HolidayLabModal'
import TextButton from 'components/Luxkit/Button/TextButton'
import { buildPreezieScript, removePreezieScript } from '../PreezieScript'
import styled from 'styled-components'
import { getImageUrl } from 'lib/image/imageUtils'
import Pane from 'components/Common/Pane'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'

const backgroundImgUrl = getImageUrl('desert_ejecwi')
const holidayLabImgUrl = getImageUrl('holiday-lab-fa-white_3x_uukvgq')
const Body = styled.div`
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow-y: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  background-image: url(${backgroundImgUrl});

  .shadowed-text {
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.44);
  }
`
const ImageWrapper = styled.div`
  display: inline-block;
`

const ResponsiveImage = styled.img`
  height: auto;

  @media (min-width: 1000px) {
    width: 45%
  }

  @media (min-width: 600px) and (max-width: 999px){
    width: 55%
  }

  @media (max-width: 599px) {
    width: 65%
  }
`

const HolidayLabRoot = styled(Pane)`
  padding: 2.5vh 9vw 2.5vh;
  text-align: center;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);

  @media (min-width: 1200px) {
    width: 55%
  }

  @media (max-width: 1199px) and (min-width: 600px){
    width: 85%
  }

  @media (max-width: 599px) {
    width: 90%
  }
`

interface Props {
}

interface State {
  holidayLabOpen: boolean;
}

class HolidayLabPage extends Component<React.PropsWithChildren<Props>, State> {
  state: State = {
    holidayLabOpen: false,
  }

  componentDidMount() {
    buildPreezieScript(document)
  }

  componentWillUnmount() {
    removePreezieScript(document)
  }

  toggleHolidayLab = () => {
    this.setState({
      holidayLabOpen: !this.state.holidayLabOpen,
    })
  }

  onClickStart = () => {
    if (!this.state.holidayLabOpen && window.PREEZIE_GUIDE) {
      this.toggleHolidayLab()
    }
  }

  onClickClose = () => {
    if (this.state.holidayLabOpen) {
      this.toggleHolidayLab()
    }
  }

  render() {
    return (
      <Body>
        <HolidayLabRoot axis="inline">
          <ImageWrapper>
            <ResponsiveImage src={holidayLabImgUrl} alt="Holiday Lab"/>
          </ImageWrapper>
          <Spacing mt={25}>
            <Heading variant="heading3" colour="neutral-eight" className="shadowed-text">
              Welcome to the Virtual Holiday Lab
            </Heading>
          </Spacing>
          <Spacing mt={35}>
            <BodyText variant="large" colour="neutral-eight" className="shadowed-text">
              At Luxury Escapes we partner with the world’s most-loved travel
              brands to create your perfect holiday. From tours in exotic
              locations to relaxed beachside stays, our experts search the globe
              to handpick the world's best escapes.
            </BodyText>
          </Spacing>
          <Spacing mt={35}>
            <BodyText variant="large" colour="neutral-eight" className="shadowed-text">
              We truly believe there’s no better way to stay inspired than by
              planning your next escape. Take our short sensory quiz to discover a
              personalised recommendation for your 2020 travel plans.
            </BodyText>
          </Spacing>

          <Spacing mt={35}>
            <TextButton kind="primary" size="large" onClick={this.onClickStart}>Start</TextButton>
          </Spacing>
        </HolidayLabRoot>
        <HolidayLabModal
          isOpen={this.state.holidayLabOpen}
          onRequestClose={this.onClickClose}
        />
      </Body>
    )
  }
}

export default HolidayLabPage
